var _style, _path, _path2, _g, _g2, _g3, _path3, _path4, _path5, _g4, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 527",
    style: {
      enableBackground: "new 0 0 500 527"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.4;fill:url(#SVGID_1_);enable-background:new    ;}\n\t.st1{opacity:0.7;fill:#FFFFFF;enable-background:new    ;}\n\t.st2{opacity:0.2;}\n\t.st3{fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st4{fill:none;stroke:#000000;stroke-miterlimit:10;}\n\t.st5{fill:#FFFFFF;stroke:#263238;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st6{fill:none;stroke:#263238;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st7{fill:#222F3E;stroke:#263238;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st8{fill:#263238;}\n\t.st9{fill:#FECA57;stroke:#263238;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st10{fill:#222F3E;stroke:#222F3E;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st11{fill:#263238;stroke:#263238;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st12{fill:#F368E0;stroke:#263238;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st13{fill:#8C8C8C;stroke:#263238;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st14{fill:#222F3E;}\n\t.st15{fill:none;stroke:#757575;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st16{fill:url(#SVGID_2_);}\n\t.st17{fill:url(#SVGID_3_);}\n\t.st18{fill:url(#SVGID_4_);}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.0859,
    y1: 223.345,
    x2: 487.9366,
    y2: 223.345
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.118836e-7,
    style: {
      stopColor: "#FECA57"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F368E0"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M462.8,328.6c34.5-81.6,38.8-196.9-20.6-268.5C409.5,20.7,357.9,7.6,308.7,4.6C264.7,2,217.5,3,177.4,23.9 C109.5,59.3,107.8,143.4,57,193c-41,40-58,97-23,172s100,92,164,68s93-29,170-17c35.4,5.5,61.1-21,76.6-49.6 C451.3,354,457.4,341.5,462.8,328.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M462.8,328.6c34.5-81.6,38.8-196.9-20.6-268.5C409.5,20.7,357.9,7.6,308.7,4.6C264.7,2,217.5,3,177.4,23.9 C109.5,59.3,107.8,143.4,57,193c-41,40-58,97-23,172s100,92,164,68s93-29,170-17c35.4,5.5,61.1-21,76.6-49.6 C451.3,354,457.4,341.5,462.8,328.6z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Graphics"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "115.1,6.2 159.6,6.2 159.6,65 103.9,65  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "98.1,65 84.5,65 84.5,6.2 109.3,6.2  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 90.2,
    y: 23.2,
    className: "st3",
    width: 8.2,
    height: 8.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.3,
    y: 23.2,
    className: "st3",
    width: 8.2,
    height: 8.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.4,
    y: 23.2,
    className: "st3",
    width: 8.2,
    height: 8.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.5,
    y: 23.2,
    className: "st3",
    width: 8.2,
    height: 8.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.6,
    y: 23.2,
    className: "st3",
    width: 8.2,
    height: 8.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.7,
    y: 23.2,
    className: "st3",
    width: 8.2,
    height: 8.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 90.2,
    y: 34.7,
    className: "st3",
    width: 8.2,
    height: 8.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.3,
    y: 34.7,
    className: "st3",
    width: 8.2,
    height: 8.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.4,
    y: 34.7,
    className: "st3",
    width: 8.2,
    height: 8.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.5,
    y: 34.7,
    className: "st3",
    width: 8.2,
    height: 8.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.6,
    y: 34.7,
    className: "st3",
    width: 8.2,
    height: 8.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.7,
    y: 34.7,
    className: "st3",
    width: 8.2,
    height: 8.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 90.2,
    y: 46.2,
    className: "st3",
    width: 8.2,
    height: 8.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.3,
    y: 46.2,
    className: "st3",
    width: 8.2,
    height: 8.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.4,
    y: 46.2,
    className: "st3",
    width: 8.2,
    height: 8.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.5,
    y: 46.2,
    className: "st3",
    width: 8.2,
    height: 8.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.6,
    y: 46.2,
    className: "st3",
    width: 8.2,
    height: 8.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.7,
    y: 46.2,
    className: "st3",
    width: 8.2,
    height: 8.2
  })), /*#__PURE__*/React.createElement("rect", {
    x: 90.5,
    y: 14.3,
    className: "st3",
    width: 63.8,
    height: 2.9
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "442.2,73.4 470.3,73.4 470.3,132.3 463,132.3  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "458,132.3 395.2,132.3 395.2,73.4 435.6,73.4  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 400.9,
    y: 90.5,
    className: "st3",
    width: 8.2,
    height: 8.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412,
    y: 90.5,
    className: "st3",
    width: 8.2,
    height: 8.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.1,
    y: 90.5,
    className: "st3",
    width: 8.2,
    height: 8.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434.2,
    y: 90.5,
    className: "st3",
    width: 8.2,
    height: 8.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 445.3,
    y: 90.5,
    className: "st3",
    width: 8.2,
    height: 8.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 456.4,
    y: 90.5,
    className: "st3",
    width: 8.2,
    height: 8.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 400.9,
    y: 101.9,
    className: "st3",
    width: 8.2,
    height: 8.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412,
    y: 101.9,
    className: "st3",
    width: 8.2,
    height: 8.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.1,
    y: 101.9,
    className: "st3",
    width: 8.2,
    height: 8.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434.2,
    y: 101.9,
    className: "st3",
    width: 8.2,
    height: 8.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 445.3,
    y: 101.9,
    className: "st3",
    width: 8.2,
    height: 8.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 456.4,
    y: 101.9,
    className: "st3",
    width: 8.2,
    height: 8.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 400.9,
    y: 113.4,
    className: "st3",
    width: 8.2,
    height: 8.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412,
    y: 113.4,
    className: "st3",
    width: 8.2,
    height: 8.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.1,
    y: 113.4,
    className: "st3",
    width: 8.2,
    height: 8.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434.2,
    y: 113.4,
    className: "st3",
    width: 8.2,
    height: 8.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 445.3,
    y: 113.4,
    className: "st3",
    width: 8.2,
    height: 8.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 456.4,
    y: 113.4,
    className: "st3",
    width: 8.2,
    height: 8.2
  })), /*#__PURE__*/React.createElement("rect", {
    x: 401.2,
    y: 81.5,
    className: "st3",
    width: 63.8,
    height: 2.9
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M47.4,167.5v-30.7c0-2.1,1.7-3.8,3.8-3.8h48c2.1,0,3.8,1.7,3.8,3.8V181H47.4v-6.8"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 48.1,
    y1: 143.4,
    x2: 102.3,
    y2: 143.4
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "61.1,152.5 53,152.5 53,158.7 97.4,158.7 97.4,152.5 69.4,152.5  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 165.7,
    className: "st3",
    width: 44.5,
    height: 6.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M288,16.7c-5.5-5-12.8-8-20.8-8c-17.1,0-31.1,13.9-31.1,31.1c0,8.5,3.4,16.3,9,21.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M248.7,64.7c5.2,3.8,11.6,6.1,18.5,6.1c17.1,0,31.1-13.9,31.1-31.1c0-7.9-2.9-15.1-7.8-20.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "281.4,39.7 267.1,39.7 267.1,63.9  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M47.3,61.2c-7.5,1.2-13.2,7.6-13.2,15.4c0,8.6,7,15.6,15.6,15.6c1.9,0,3.8-0.3,5.5-1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M60.3,88.2c3.1-2.9,5.1-7,5.1-11.5c0-8-6-14.6-13.7-15.5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 49.7,
    y1: 68.7,
    x2: 49.7,
    y2: 84.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 57.7,
    y1: 76.7,
    x2: 41.8,
    y2: 76.7
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 470,
    cy: 198.4,
    r: 15.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 470,
    y1: 190.4,
    x2: 470,
    y2: 206.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 478,
    y1: 198.4,
    x2: 462.1,
    y2: 198.4
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Task_Panel_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M441,522.9H90.3l0.4-407.4c0-8.2,4.7-14.8,10.5-14.8h329.8c5.8,0,10.5,6.6,10.5,14.8L441,522.9z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 337.7,
    y1: 139.3,
    x2: 428.5,
    y2: 139.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 110.1,
    y1: 139.3,
    x2: 332.4,
    y2: 139.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M430.9,93.7H101.1c-5.8,0-10.5,4.8-10.5,10.7v8.2h350.8v-8.2C441.4,98.5,436.7,93.7,430.9,93.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M109.8,104.2c0-1.8-1.4-3.2-3.2-3.2c-1.8,0-3.2,1.4-3.2,3.2s1.4,3.2,3.2,3.2 C108.3,107.4,109.8,106,109.8,104.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M122.4,104.2c0-1.8-1.4-3.2-3.2-3.2s-3.2,1.4-3.2,3.2s1.4,3.2,3.2,3.2S122.4,106,122.4,104.2z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st5",
    cx: 131.9,
    cy: 104.2,
    rx: 3.2,
    ry: 3.2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M113.7,162v-13.2H111v-1.5h6.9v1.5h-2.7V162H113.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M119.9,159.1l-0.6,3h-1.5l2.8-14.7h2.3l2.8,14.7h-1.6l-0.6-3H119.9z M120.1,157.6h3.2l-1.6-8.5 L120.1,157.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M133.2,150.8v0.4h-1.5v-0.5c0-1.3-0.5-2.1-1.6-2.1s-1.6,0.8-1.6,2.1c0,3.3,4.8,3.6,4.8,7.8 c0,2.2-1.1,3.7-3.3,3.7s-3.2-1.4-3.2-3.7v-0.8h1.5v0.9c0,1.3,0.5,2.1,1.7,2.1c1.1,0,1.7-0.8,1.7-2.1c0-3.3-4.8-3.6-4.8-7.7 c0-2.3,1-3.7,3.2-3.7C132.1,147.1,133.2,148.6,133.2,150.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M137,155.6l-0.8,1.4v4.9h-1.6v-14.7h1.6v7.1l3.8-7.1h1.6L138,154l3.8,8h-1.6L137,155.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M149.1,150.8v0.4h-1.5v-0.5c0-1.3-0.5-2.1-1.6-2.1s-1.6,0.8-1.6,2.1c0,3.3,4.8,3.6,4.8,7.8 c0,2.2-1.1,3.7-3.3,3.7s-3.2-1.4-3.2-3.7v-0.8h1.5v0.9c0,1.3,0.5,2.1,1.7,2.1c1.1,0,1.7-0.8,1.7-2.1c0-3.3-4.8-3.6-4.8-7.7 c0-2.3,1-3.7,3.2-3.7C148.1,147.1,149.1,148.6,149.1,150.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M426.4,201.5h-79c-2.6,0-4.7-2.1-4.7-4.7v-22.3c0-2.6,2.1-4.7,4.7-4.7h79c2.6,0,4.7,2.1,4.7,4.7v22.3 C431.1,199.4,429,201.5,426.4,201.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M355.3,37.1c0,0-11.6,5.1-17.7,6.7c-6,1.6-12.5,4.2-14.2,9.3c-1.6,5.1-8.9,24.8-9.4,29s7,11.7,7,11.7h96.7 c0,0,1.8-24.5-2.2-32.8s-16-15.5-19.5-16.9c-3.5-1.4-12.6-5.8-16.3-6.5C376.2,36.8,359.5,35.5,355.3,37.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M323.3,71c0,0,5.7-2,11,2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M331,73c0,0,3.3,0,6,2.5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M340.9,61.8c0.8,1.3,1.4,3,1.2,5.2c-0.5,5.8-2.5,10-2.5,10"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M337.5,58.4c0,0,1.2,0.7,2.4,2.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M343.4,61.5c0,0,1.9,5.6,0.8,10.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M393.7,65c0,0-2.3,8.1-2.1,10.7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "356.7,57 361,64.7 364.6,76.4 369.7,65.8 374.6,57.2 365,55.8  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 361,
    y1: 64.7,
    x2: 369.7,
    y2: 65.8
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M356.2,43.4c0,0-1.6,2.1-2.6,4.9s-2.6,12.3-2.6,12.3s9.1-0.5,11.4-0.5s6,0.2,6.7,0.2s11.2,6.3,11.2,6.3 s1.9-10.7-0.2-16.7C378.1,43.8,363.9,36.6,356.2,43.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M361.1,56.5l3.7,7.7l7.5-8.4C372.3,55.8,365.3,57.9,361.1,56.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M392.3,143.8l-3.6,6.6c0,0-4.4,0.9-4.9,1.9c-0.5,0.9-2.8,4.9-4,6c-1.2,1.2-3.5,2.8-1.4,3.7 c2.1,0.9,5.8-3.3,5.8-3.3l2.1-1.2c0,0,0.3,2.6-0.7,5.5c-1.4,3.9-3,8.7-2.7,9.2c1,2.5,2.6,0.7,2.6,0.7l3.1-7.3l0.5-0.4 c0,0-0.6,8.3-0.6,8.4c-0.1,1.5,1.2,3.3,2.4,1.8l2.8-8.8v7.9c0,1.2,1.1,2.2,2.3,1.9c0.1,0,0.2-0.1,0.3-0.1 c0.9-0.5,1.3-10.2,1.3-10.2l1.9,7c0.2,0.8,1,1.3,1.8,0.9c0.2-0.1,0.3-0.2,0.4-0.4c0.2-0.7-0.5-11.9-0.5-11.9l-0.5-11.6l0.7-3.9 L392.3,143.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M396.7,65.9c0,0-3.7,7.9-3.3,10.7s11.3,29.5,11.3,29.5l-13.5,38.8l10.7,2.6c0,0,18.3-27.2,20.2-33 c1.6-4.9,1.4-8.8,1.4-10.2c0-1.4-4.3-33.2-6.9-38.8c-2.6-5.6-5.8-9.1-5.8-9.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M406.4,105.1c0,0,4.2-5.8,6.7-9.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 412.4,
    y1: 93.5,
    x2: 407.3,
    y2: 100
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 392.2,
    y1: 141.2,
    x2: 403.6,
    y2: 143.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M317.7,75.5c-0.8,0.7-1.8,1.7-2.9,3.2c-2.1,3-0.9,9.5,0.5,11.6c1.4,2.1,7,3.5,7,3.5h45.1l0.9-7.6 c-1,0-1.6,0-1.6,0s-8.1-2.6-14-4.2c-5.8-1.6-17.3-6.5-20.7-7.2c-3.2-0.7-6-0.6-8-0.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M375.1,93.8l-0.2-0.3c0,0,4.7-0.4,5.3-0.6c0.6-0.2,2.6-0.4,2.6-0.4l6.8,1.4h6.7l-0.7-1.2l-6-3.7l-5.2-2.6 c-5.4-2.7-11.9,0.6-17.6-0.2c0,0,1,0.1,1.1,0.1l-0.9,7.5H375.1z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 384.4,
    y1: 88.6,
    x2: 395.1,
    y2: 93.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 363.7,
    y1: 85.8,
    x2: 363.5,
    y2: 93.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M354.9,30.1c0,0-3-4-3.3-8.8c-0.2-4.9,2.1-5.8,2.1-5.8s-3.5-5.6,4.2-8.8c7.7-3.3,19.3-5.1,25.8-1.6 c6.5,3.5,8.8,11.6,8.6,17.2c-0.2,5.6-3.5,12.1-3.5,12.1l-5.1,6.3c0,0-3.3,1.2-4-0.2c-0.7-1.4-4.6-5.6-6.7-5.6s-7.4,0-10.2-1.2 C360,32.4,354.9,30.1,354.9,30.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M354.4,23.1c0,0-0.2,14.2-0.2,17.2c0,3,0,6,1.4,9.1c1.4,3,2.6,11.2,8.8,11.6s15.3-6,17-9.5 c1.6-3.5,2.6-9.5,2.6-9.5s5.6-3.7,6.5-8.1c0.9-4.4-0.9-6.5-2.1-4.4s-2.8,7.4-3.5,7.9c-0.7,0.5-1.6-2.8-1.6-2.8s-3.5,1.4-4,0 c-0.5-1.4,1.9-8.1,1.9-8.1s-7.7,2.1-9.3,2.1s-5.1-1.2-5.1-1.2l6.7,4.2c0,0-4.6,2.1-9.3,0.7c-4.6-1.4-8.1-9.1-8.1-9.1 L354.4,23.1L354.4,23.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M361.4,38v2.8c0,0-3,7.9-2.6,9.3s4.6,0.7,5.6,0.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M360.9,52.4c0,0,4.4,2.8,9.1,0.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M367.6,42c0,0,3.5,2.8,8.1,1.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M367.9,37.8c0,0,5.1-1.9,8.4,1.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M356,38.2c0,0,0.9,2.1,5.4,2.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M360.4,35.9c0,0-1.6-2.8-4-1.9"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "364.6,76.4 358,135.6 366.5,147.5 374.4,135.6  "
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M106.1,226.4v9.7c0,0,99.6-4.1,220.4-6.1L106.1,226.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.6,
    y: 169.7,
    className: "st5",
    width: 225.9,
    height: 60.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M101.5,239.9c0,0,3.3-8.7,4-9.6c0.7-0.9,1.8-3.1,3.8-3.1s5.6,0.2,7.1-0.4s3.6-0.7,3.1,0.7 c-0.4,1.3-3.1,1.8-3.1,1.8l11.6,0.9c0,0-3.3,3.1-4.9,3.8c-1.6,0.7-4.9,1.3-4.9,1.3s-2.7,1.8-4.5,2.2c-1.8,0.4-4.5,0.7-4.5,0.7 l-2.4,4.5L101.5,239.9z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 116.4,
    y1: 229.3,
    x2: 111.3,
    y2: 230.6
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "82.6,200.9 78.8,207.3 81.1,212.4 87.3,207.8 90.4,205.5 90.4,192.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M81.4,204.4c0,0,1.8-9.1,2.7-10.3c0.9-1.1,4.5-3.8,5.6-4s2.7,0.4,1.8,1.8c-0.9,1.3-3.8,3.3-3.8,3.3 s1.6,4.5,0.4,6.9s-3.6,3.6-3.6,3.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "78.2,206.1 82,215.7 62.6,230.4 58.4,215.2  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M61.5,366.8l0.8,9.5c0,0-5,10.5-4.5,19.8s1.5,36,1.5,37.5s-2.5,3.3-0.8,9.5c0.5,1.7,4.8,0.5,9,3.3 s9.5,4.5,12.8,4.5s5,0,5-1.5s-4.8-3.5-6.8-5.5s-8.3-10.3-8.8-11.3s1.8-15.8,3.3-21.5s5.8-19.5,7.5-29.3S83,364,83,364 L61.5,366.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M58.5,443l0.5,6.8h3.5l1.5-5.5C64,444.3,59.8,442.8,58.5,443z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M80.3,450.8c3.2-0.3,5,0,5-1.5s-4.8-3.5-6.8-5.5c-1.6-1.6-5.7-6.9-7.7-9.6c-0.9,0.7-2.2,1.3-3.6,1.4 c-3.8,0.3-8-2-8-2c0,1.5-2.5,3.3-0.8,9.5c0.5,1.7,4.9,1.4,8.3,5.5C70.1,452.5,79.8,450.8,80.3,450.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M32.3,359.5l0.5,14c0,0-6.5,8.8-7.8,17.3s-5.5,41.8-5.5,45s-2,13.8-1,14.5s12.5,0,12.5,0s0.5-1,0.5-3.5 S29.5,436,30,434s2.3-8.3,2.3-8.3s7.8-20.3,11-26.5s6-15.3,7.8-20.8s3.3-13.3,3.3-13.3L32.3,359.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M29.9,434.4c-3.5-4.9-9.1-1.9-10.3-1.3c-0.1,1.3-0.2,2.2-0.2,2.6c0,3.3-2,13.8-1,14.5s12.5,0,12.5,0 s0.5-1,0.5-3.5C31.5,444.4,29.7,436.9,29.9,434.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M31,450.3c-0.5-1.5-4-7.5-4-7.5l-6.5,0.3c-2.3,2.5-2,7.3-2,7.3C19.5,451,31,450.3,31,450.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M27,442.8c0,0-2.3-2-4-1.3s-2.5,1.5-2.5,1.5l0.3,7.5h4.5L27,442.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M26.8,309.8c0,0-2,5-2.3,11.5s1.5,38.5,1.5,38.5s12.5,8.5,33.5,9.3s30.8-5,30.8-5s-0.5-38.5-3-47.8 s-7-13-7-13s-10,3-25.3,2.8s-25.8-3-25.8-3L26.8,309.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M33.3,232.8c0,0-6.2,11.6-7.1,20.1c-0.9,8.5,7.3,34.3,7.3,35.2s-8.7,23.2-8.7,23.2s10,4.5,21.2,6.9 s22.5,0.9,24.7,0.2l2.9-8.7l1.1,7.4c0,0,0,0.2,3.6-0.7s8-4.7,8-4.7s-5.8-13.6-8.7-17.4s-6.5-12.5-6.5-12.5l1.3-11.1 c0,0,10,8.2,10.9,8.5c0.9,0.2,14.7-16,17.6-20.7s7.6-16.7,7.6-16.7l-6.7-3.3l-2.7,2.7l-15.8,17.2c0,0-9.6-10.9-14.3-12.7 S55.6,241,55.6,241l-18-4.2l1.3-3.8C38.9,233,38,230.4,33.3,232.8z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "72.6,270.7 62.5,264.8 71.7,275.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M51.4,284.5c1,1.1,2,2.2,3.1,3.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M39.2,262.7c0,0,4.3,11.1,10.2,19.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M43.9,279.5c0,0,2.9,5.1,8.4,11"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M62.3,197.8c0,0,1.1,2,2,5.6c0.9,3.6,4,5.4,5.1,5.1c1.1-0.2,1.1,2.4,0.4,3.8c-0.7,1.3-1.8,2.4-1.8,2.4 s-0.2,5.4-0.9,9.4s-0.9,7.1-2.4,7.1c-1.6,0-8,0-8,0s-0.7,3.6-0.9,6.5c-0.2,2.9-0.2,3.3-0.2,3.3l-18-4.2l2-6.2 c0,0-11.4-5.1-5.8-14.5C39.4,206.8,52.5,194.9,62.3,197.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "56.7,231.3 53,231 56,236.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M67.7,219.7c0,0-1.8,1.3-4.5,0.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M60.8,205.9c0,0,0.5-4.2,2.7-4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M64.3,207.6c0.4,1.2,0.3,2.2-0.1,2.4c-0.4,0.1-1-0.7-1.4-1.9c-0.4-1.2-0.3-2.2,0.1-2.4 C63.3,205.6,63.9,206.4,64.3,207.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M62.3,191.1c0,0,0,0.1,0.1,0.1c2.4,3.1,2,6.5,0.1,9.7c-3.7,6.6-15,12.6-15,18.1c0,5.4,5.7,5.1,5.7,5.1 s2.3,4.8-3.4,9.1c-5.7,4.3-17.4,5.4-24.8-2.3c-2.2-2.2-3.5-5-4.3-7.7c-2.3-7.5-2.6-15.9,0.7-22.6c2.8-5.7,6-10.3,11.8-13.2 c4.6-2.2,11.8-2.8,16.9-2.5c2.5,0.1,5,0.6,7.2,1.7C59.1,187.6,61,189.5,62.3,191.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M46.7,228.7c1.9-0.3,3.2-0.9,3.2-0.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M56.5,203.7c-1.3,2-3.2,4-5.7,5.8c-7.8,5.5-16.5,11.3-12.6,16.5c1.5,2.1,3.7,2.8,5.8,2.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M59.9,195.9c0,0-0.3,1.9-1.5,4.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M41.2,211.3c-1.3,1.8-2.9,3.9-4.8,6.1c-5.5,6.3-4.7,19.1,7.6,18.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M44.7,205.9c0,0-0.6,1.1-1.7,2.8"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Plant"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 418.4586,
    y1: 109.3269,
    x2: 430.7822,
    y2: 109.3269,
    gradientTransform: "matrix(1 0 0 -1 0 526)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FECA57"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F368E0"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M421.5,411.7c-2.2,0.3-3.4,2.5-2.9,4.6c0.5,2.1,2.7,3.7,4.6,4.5c2.2,1,7.6,0.9,7.6,0.9 c0.1,0-1.2-3.5-1.3-3.8C428.3,415.4,424.6,411.3,421.5,411.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 418.8459,
    y1: 81.8186,
    x2: 497.2961,
    y2: 81.8186,
    gradientTransform: "matrix(1 0 0 -1 0 526)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FECA57"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F368E0"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M460.2,489.5c0.5-1.2,1.1-2.5,1.6-3.9c0.6-1.4,1.1-2.9,1.7-4.4c0.6,0.1,5.3,1.1,7.5,0.6 c2-0.5,4.4-1.6,5.3-3.6c0.9-1.9,0.1-4.3-2-5c-2.9-1-7.4,2.3-9,4.6c-0.1,0.1-1,1.7-1.5,2.6c0.2-0.6,0.5-1.2,0.7-1.9 c0.5-1.3,0.9-2.6,1.4-3.9c0.2-0.7,0.4-1.4,0.6-2c0.2-0.7,0.4-1.4,0.5-2.1c0.4-1.7,0.7-3.4,1-5.1c1.1,0.4,5.1,1.8,7.2,1.6 c2.1-0.1,4.6-0.9,5.8-2.7c1.2-1.8,0.8-4.3-1.2-5.3c-2.8-1.4-7.7,1.2-9.6,3.1c-0.1,0.1-1.4,1.7-2,2.5c0.2-1,0.3-2.1,0.5-3.1 c0.4-3.1,0.7-6.2,1-9.3c0.1-1,0.2-1.9,0.3-2.8c0.4,0.1,5.1,1.9,7.4,1.7c2.1-0.1,4.6-0.9,5.8-2.7c1.2-1.8,0.8-4.3-1.2-5.3 c-2.8-1.4-7.7,1.2-9.6,3.1c-0.1,0.1-1.9,2.4-2.4,3c0.2-2.1,0.5-4.2,0.8-6.2c0.4-2.8,1-5.5,1.8-8.2c0.2,0.1,5.1,1.9,7.5,1.8 c2.1-0.1,4.6-0.9,5.8-2.7c1.2-1.8,0.8-4.3-1.2-5.3c-2.8-1.4-7.7,1.2-9.6,3.1c-0.1,0.1-2.1,2.6-2.4,3c0-0.1,0.1-0.3,0.1-0.5 c0.9-2.8,2-5.4,3.2-7.7c0.7-1.4,1.5-2.6,2.2-3.9c0.9,0.4,4.9,2.4,7.1,2.5c2.1,0.1,4.7-0.4,6.1-2.1c1.4-1.6,1.2-4.2-0.6-5.4 c-2.6-1.7-7.8,0.4-9.9,2.1c-0.1,0.1-1.2,1.2-2,2c0.4-0.5,0.7-1.1,1-1.6c1.3-2,2.6-3.6,3.8-5.1c0.7-0.9,1.3-1.6,1.9-2.3 c1.1,0,5.5-0.1,7.4-1c1.9-0.9,4-2.5,4.5-4.6c0.4-2.1-0.8-4.3-3.1-4.5c-3.1-0.3-6.7,3.9-7.8,6.4c-0.1,0.2-1.2,3.8-1.2,3.8 c0,0,0,0,0.1,0c-0.6,0.7-1.2,1.4-1.9,2.2c-1.2,1.5-2.5,3.1-3.9,5.1c-1.3,1.9-2.8,4-4,6.4c-1.3,2.4-2.5,4.9-3.4,7.8 c0,0,0,0.1,0,0.1c0-0.9,0-3.4,0-3.6c-0.4-2.7-2.6-7.8-5.7-8.4c-2.2-0.4-4,1.3-4.2,3.4c-0.2,2.2,1.4,4.4,2.9,5.7 c1.7,1.5,6.5,3,6.9,3.2c-0.9,2.7-1.5,5.5-2,8.4c-0.3,1.6-0.5,3.3-0.8,5c0-0.8,0-1.5,0-1.6c-0.4-2.7-2.6-7.8-5.7-8.4 c-2.2-0.4-4,1.3-4.2,3.4c-0.2,2.2,1.4,4.4,2.9,5.7c1.6,1.4,5.6,2.8,6.7,3.1c-0.1,0.6-0.2,1.3-0.2,1.9c-0.4,3.1-0.7,6.2-1.2,9.2 c-0.2,1.1-0.4,2.1-0.5,3.2c0-0.7,0-1.3,0-1.4c-0.4-2.7-2.6-7.8-5.7-8.4c-2.2-0.4-4,1.3-4.2,3.4c-0.2,2.2,1.4,4.4,2.9,5.7 c1.5,1.3,5.2,2.6,6.5,3c-0.2,1.1-0.5,2.1-0.7,3.1c-0.2,0.7-0.3,1.4-0.6,2.1c-0.2,0.7-0.4,1.4-0.7,2c-0.5,1.3-0.9,2.6-1.4,3.8 c-0.3,0.9-0.7,1.7-1,2.5c0.2-1.1,0.5-3.1,0.5-3.3c0-1.8-0.6-4.8-1.9-6.9c0-0.3,0-0.5,0-0.8c-0.3-2.1-2.3-3.7-4.5-3.1 c-3,0.8-4.9,6-5,8.8c0,0.2,0.1,1.9,0.2,3c-0.1-0.6-0.3-1.3-0.5-2c-0.3-1.3-0.7-2.6-1-4c-0.2-0.7-0.4-1.4-0.6-2 c-0.2-0.7-0.5-1.4-0.7-2.1c-0.6-1.6-1.3-3.2-2-4.8c1.2-0.3,5.2-1.3,6.9-2.6c1.6-1.3,3.4-3.3,3.4-5.5c0-2.1-1.7-4-4-3.7 c-3.1,0.3-5.7,5.2-6.3,7.9c0,0.2-0.2,2.1-0.3,3.2c-0.4-1-0.9-1.9-1.4-2.9c-1.4-2.8-2.9-5.5-4.3-8.3c-0.5-0.8-0.9-1.7-1.3-2.5 c0.4-0.1,5.3-1.2,7.1-2.6c1.6-1.3,3.4-3.3,3.4-5.5c0-2.1-1.7-4-4-3.7c-3.1,0.3-5.7,5.2-6.3,7.9c0,0.2-0.3,3.1-0.3,3.8 c-1-1.9-1.9-3.7-2.8-5.6c-1.2-2.6-2.2-5.2-3-7.8c0.2,0,5.3-1.2,7.2-2.6c1.6-1.3,3.4-3.3,3.4-5.5c0-2.1-1.7-4-4-3.7 c-3.1,0.3-5.7,5.2-6.3,7.9c0,0.2-0.3,3.3-0.3,3.8c0-0.1-0.1-0.3-0.2-0.5c-0.8-2.8-1.3-5.6-1.6-8.2c-0.2-1.5-0.3-3-0.3-4.5 c1-0.1,5.4-0.7,7.3-1.8c1.8-1.1,3.7-2.9,3.9-5.1c0.2-2.1-1.3-4.1-3.5-4.1c-3.1,0-6.3,4.6-7.1,7.2c0,0.1-0.4,1.6-0.6,2.7 c0-0.6,0-1.3,0-1.9c0-2.3,0.1-4.5,0.3-6.4c0.1-1.1,0.2-2,0.3-3c0.9-0.6,4.5-3.1,5.6-4.9c1.1-1.8,2-4.3,1.1-6.3 c-0.8-2-3.1-3.1-5-2.1c-2.7,1.4-3.5,6.9-3,9.7c0,0.2,1.1,3.8,1.1,3.8c0,0,0,0,0,0c-0.1,0.9-0.2,1.8-0.4,2.8 c-0.2,1.9-0.4,4-0.4,6.4s-0.1,4.9,0.2,7.6c0.2,2.7,0.6,5.5,1.4,8.4c0,0,0,0.1,0,0.1c-0.5-0.8-1.9-2.9-2-3 c-1.8-2.1-6.5-5.1-9.4-3.9c-2,0.9-2.6,3.3-1.6,5.2c1,1.9,3.6,2.9,5.6,3.1c2.3,0.3,7.1-1.1,7.5-1.2c0.8,2.7,1.8,5.4,2.9,8.1 c0.7,1.5,1.4,3.1,2.1,4.6c-0.4-0.6-0.8-1.2-0.9-1.3c-1.8-2.1-6.5-5.1-9.4-3.9c-2,0.9-2.6,3.3-1.6,5.2c1,1.9,3.6,2.9,5.6,3.1 c2.1,0.3,6.2-0.8,7.3-1.1c0.3,0.6,0.6,1.2,0.9,1.8c1.4,2.8,2.8,5.6,4.1,8.3c0.5,1,0.9,2,1.3,2.9c-0.4-0.6-0.7-1-0.8-1.1 c-1.8-2.1-6.5-5.1-9.4-3.9c-2,0.9-2.6,3.3-1.6,5.2c1,1.9,3.6,2.9,5.6,3.1c2,0.3,5.8-0.7,7.1-1.1c0.4,1,0.8,2,1.1,3 c0.2,0.7,0.5,1.3,0.7,2c0.2,0.7,0.4,1.4,0.6,2.1c0.3,1.3,0.6,2.7,0.9,4c0.2,0.9,0.4,1.8,0.5,2.6c-0.5-1-1.4-2.9-1.5-3 c-1.5-2.3-5.7-6-8.7-5.2c-2.2,0.5-3.1,2.9-2.4,4.9c0.8,2,3.1,3.4,5.1,4c2.2,0.7,7,0.1,7.6,0c0.3,1.4,0.5,2.8,0.8,4.2 c0.4,2,0.6,3.8,0.9,5.5h-2.8v1.5c4.4,0.6,8.9,1.1,13.3,1.4v-2.9H460.2z M458.1,489.5h-4.6c-0.3-1.8-0.6-3.7-1.1-5.9 c-0.3-1.5-0.6-3-1-4.6c0.4-0.1,2.4-1,4.2-2c1.6,1.7,5.6,3.7,6.2,4c-0.5,1.4-1.1,2.7-1.6,3.9C459.4,486.5,458.8,488,458.1,489.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 470.4923,
    y1: 110.8733,
    x2: 479.0844,
    y2: 110.8733,
    gradientTransform: "matrix(1 0 0 -1 0 526)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FECA57"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F368E0"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M478,422c0,0,1-3.6,1-3.8c0.4-2.7-0.5-8.2-3.3-9.6c-2-1-4.2,0.2-5,2.2c-0.8,2,0.2,4.6,1.3,6.3 C473.4,419.1,478,422,478,422z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M451.5,489.5h-2.8 M448.7,489.5v33.5H462v-33.5h-1.8"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Floor"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 15.1,
    y1: 450.7,
    x2: 90.3,
    y2: 450.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 477.1,
    y1: 522.9,
    x2: 487.9,
    y2: 522.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 467.8,
    y1: 522.9,
    x2: 472.1,
    y2: 522.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 90.3,
    y1: 522.9,
    x2: 464.8,
    y2: 522.9
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.98d12f5e37c7a51b22cb98217e5b7f0b.svg";
export { ForwardRef as ReactComponent };